import { createSlice } from '@reduxjs/toolkit';
import { fetchCampaignBriefChatData } from '../thunks/campaignBriefThunks';

const initialState = {
    chatHistories: null,
    campaignBriefdata: null,
    loading: false,
    error: null,
};

const campaignBriefSlice = createSlice({
    name: 'campaignBrief',
    initialState,
    reducers: {
        setChatHistories(state, action) {
            state.chatHistories = action.payload;
        },
        clearCampaignBrief(state) {
            state.chatHistories = null;
            state.campaignBriefdata = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignBriefChatData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignBriefChatData.fulfilled, (state, action) => {
                state.loading = false;
                state.campaignBriefdata = action.payload;
            })
            .addCase(fetchCampaignBriefChatData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch campaign brief data';
            });
    },
});

export const {
    setChatHistories,
    clearCampaignBrief
} = campaignBriefSlice.actions;

export default campaignBriefSlice.reducer;